import { errorCatch, getTokenHeaders } from '../helper';
import { getAxios } from '../axios';
import {
  ENDPOINT_PRODUCT_GROUPS
} from '../../config/endpoints';
import { Messages } from '../../config';
import { FEATURE_ARCHIVE } from '../../config/features';
import { ARCHIVE_PRODUCT_GROUPS } from '../../config/constants/ProductGroups';

/**
 * Get list of all product groups
 * @param {object} payload
 * @param {boolean} [payload.disablePagination]
 * @returns {Promise<T>}
 */
export function getProductGroups(payload) {
  let headersAndParams = getTokenHeaders( payload.pagination ? payload.pagination : payload.disablePagination ? {} : { per_page: 15 } );
  return getAxios( false )
    .get(
      ENDPOINT_PRODUCT_GROUPS
      ,
      {
        headers: headersAndParams.headers,
        params: {
          ...headersAndParams.params,
          disablePagination: payload.disablePagination
        },
      }
    )
    .then( response => {
      if (
        ! response ||
        ! response.data ||
        ! response.data.data ||
        response.status !== 200
      ) {
        return null;
      }

      if (! FEATURE_ARCHIVE) {
        response.data.data = response.data.data.filter(
          (productGroup) => ! ARCHIVE_PRODUCT_GROUPS.includes( productGroup.name )
        );
      }

      return {
        data: response.data.data
      };
    } )
    .catch(
      e => {
        errorCatch( e, {
          401: Messages.UNAUTHENTICATED_ERROR,
          403: Messages.UNAUTHORIZED_ERROR,
          404: Messages.NOT_FOUND_ERROR,
        } );

        return e.response;
      }
    );
}
